import React, { Fragment, useEffect, useState } from 'react';
import { Grid, Container, Typography } from '@mui/material';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import './Feedback.css';

import FeedbackView from './componets/FeedbackView';
import FeedbackScreen from './componets/FeedBackSuperUserView';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';

const Feedback = () => {
  const appUser = useSelector((state: RootStateType) => state.appReducer?.user);
  const [superUserLogged, setSuperUserLogged] = useState<boolean>(false);
  useEffect(() => {
    if (appUser.Roles.split(',').includes('Super User')) {
      setSuperUserLogged(true)
    } else {
      setSuperUserLogged(false)
    }
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>Feedback</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
      {superUserLogged ? <FeedbackScreen /> : <FeedbackView />}
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </Fragment>
  );
};

export default Feedback;
